<template>
  <div class="border-default border-2">
    <slot />
  </div>
</template>

<script>
export default {};
</script>
